<div
  class="d-flex justify-content-between"
  style="
    position: fixed;
    width: 67%;
    top: 0;
    height: 60px;
    background-color: #fff;
    z-index: 9;
  "
>
  <h2 mat-dialog-title style="position: relative" class="pt-3">
    {{
      data.type == "tooltip"
        ? "Tooltip "
        : data.type == "faq"
        ? "FAQ "
        : data.type == "userguide"
        ? "User Guide "
        : "Workflow "
    }}{{ "Form.History" | translate }}
    <div
      style="
        position: relative;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #f5f5f5;
      "
    ></div>
  </h2>
  <button
    id="close-button"
    type="button"
    style="top: 15px !important; right: 0 !important"
    class="close"
    data-dismiss="alert"
    aria-label="Close"
    (click)="onNoClick()"
  >
    <span aria-hidden="true">×</span>
  </button>
</div>
<div
  style="
    position: relative;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    margin-top: 37px;
    margin-bottom: 15px;
    background-color: #717171;
  "
></div>
<div class="popup-scrl">
  <mat-dialog-content style="max-height: 90vh !important">
    <div *ngIf="changes.length > 0; else noHistory">
      <div *ngFor="let change of changes">
        <label>Changed on: {{ change.updatedAt | date : "dd MMM yyyy" }}</label>
        <div *ngFor="let key of change.changes | keyvalue">
          <div *ngIf="key.value.oldValue && key.value.newValue">
            <ng-container *ngIf="isHtmlField(key.key); else plainText">
              <p>
                <label>{{ key.key }}:</label> changed from
                "<label [innerHTML]="sanitizeHtml(key.value.oldValue)"></label>" to
                "<label [innerHTML]="sanitizeHtml(key.value.newValue)"></label>"
              </p>
            </ng-container>
            <ng-template #plainText>
              <p>
                <label>{{ key.key }}:</label> changed from "{{
                  key.value.oldValue
                }}" to "{{ key.value.newValue }}"
              </p>
            </ng-template>
          </div>
        </div>
        <div *ngIf="change.changes.workflowSteps">
          <h5>Workflow Steps Changes:</h5>

          <div *ngFor="let stepChange of change.changes.workflowSteps">
            <div *ngFor="let key of stepChange.changes | keyvalue">
              <ng-container *ngIf="isHtmlField(key.key); else plainStepText">
                <p>
                  <label>{{ key.key == "intro" ? "Text" : key.key }}:</label> {{key.value.name}} changed from
                  "<label [innerHTML]="sanitizeHtml(key.value.oldValue)"></label>" to 
                  "<label [innerHTML]="sanitizeHtml(key.value.newValue)"></label>"
                </p>
              </ng-container>

              <ng-template #plainStepText>
                <p>
                  <label>{{ key.key == "intro" ? "Text" : key.key }}:</label> {{key.value.name}} changed from "{{
                    key.value.oldValue
                  }}" to "{{ key.value.newValue }}"
                </p>
              </ng-template>
            </div>
          </div>
        </div>
        <hr class="history-divider" />
      </div>
    </div>
    <ng-template #noHistory>
      <p>No history found</p>
    </ng-template>
  </mat-dialog-content>
</div>
